// スカウトメッセージに含められないワード（外部連絡先への誘導防止）
// 判定と、送信フォームのワード一覧モーダルの両方で参照する
export const SCOUT_NG_WORDS = [
  '{name}', 'mail', '@', 'tel', '070', '080', '090', 'http', '.jp', '.com', '.net'
] as const;

// 自社URLは例外として判定対象から除外する
const ALLOWED_URL_PATTERN = /https:\/\/www\.readytofashion\.jp(?=[/?#\s]|$)\S*/g;

// 全角・半角カナはNFKCで半角英数・全角カナに揃えて判定する
// 例: containsScoutNgWord('ＴＥＬください') => true
//     containsScoutNgWord('https://www.readytofashion.jp/recruitments/1') => false
export const containsScoutNgWord = (message: string): boolean => {
  const checkTarget = message.normalize('NFKC').toLowerCase().replace(ALLOWED_URL_PATTERN, '');
  return SCOUT_NG_WORDS.some(word => checkTarget.includes(word));
};
